import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import { useState } from "react";
import axios from "axios";
import VerComentarios from "./VerComentarios";
import Cookies from "universal-cookie";

const CreaComentarios = (props) => {
  const cookie = new Cookies();
  const [postNombre, setPostNombre] = useState("");
  const [loading, setLoading] = useState({
    postData: false,
    avanza: false,
    devuelve: false,
  });

  const postData = async (e) => {
    e.preventDefault();
    setLoading((prev) => ({ ...prev, postData: true }));

    // Convertir la fecha a formato ISO 8601 compatible con .NET
    const fecha = new Date();
    // Ajustar la fecha a la zona horaria de Bogotá
    const fechaBogota = new Intl.DateTimeFormat("sv-SE", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Asegura el formato 24 horas
    }).format(fecha);

    // Reemplazar los separadores para obtener formato ISO 8601 sin "Z"
    const fechaCreacion = fechaBogota.replace(" ", "T");

    console.log(fechaCreacion);

    try {
      const response = await axios.post(
        "https://contratosback.azurewebsites.net/api/v1/CreaComentarios",
        {
          // eslint-disable-next-line react/prop-types
          solicitudId: JSON.stringify(props.id),
          comentarios: postNombre,
          usuarioId: cookie.get("id"),
          fechaCreacion,
        },
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        }
      );
      console.log(response.data);
      alert("Creado con éxito!");
    } catch (error) {
      console.error(error);
      alert("Error al crear: " + error.message);
    } finally {
      setLoading((prev) => ({ ...prev, postData: false }));
    }
  };

  console.log(window.location.href);
  return (
    <>
      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="bg-light shadow">
              <CardHeader className="border-0" />
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">Comentarios</h6>
                  <FormGroup>
                    <Input
                      type="textarea"
                      placeholder="Escriba aquí"
                      onChange={(e) => setPostNombre(e.target.value)}
                    />
                  </FormGroup>
                  <button
                    className="btn btn-primary btn-lg"
                    onClick={postData}
                    disabled={loading.postData}
                  >
                    {loading.postData ? "Guardando..." : "Guardar Comentario"}
                  </button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <br></br>
      <br></br>
      <br></br>
      <br></br>

      {cookie.get("tipo_Usuario") != null && (
        // eslint-disable-next-line react/prop-types
        <VerComentarios id={props.id} />
      )}
    </>
  );
};

export default CreaComentarios;
